/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../utils';
/* eslint-disable array-callback-return */
const ApplicationAndCompany = (props) => {
    const {
        title,
        i18n,
        content,
        dataId,
        staticData,
        selectedLanguage
    } = props;
    const { itemValue, idTypeValue, comDocType } = i18n;
    return (
         <div className="preview-list" data-id={dataId}>
            <h3 className="preview-h3">{title}</h3>
            <div className="preview-list-box">
                {
                    content && Object.keys(content).map((item, index) => {
                        let defaultValue = content[item];
                        //之前只有1，2，3  现加了4，5，6， 加7台湾居民来往大陆通行证
                        //RBBOB-15552
                        if (item === 'idType') {
                            if(parseInt(defaultValue, 10) === 1){//中国身份证
                                defaultValue = idTypeValue[0];
                            } else if(parseInt(defaultValue, 10) === 4){//港澳居民往来内地通行证
                                defaultValue = idTypeValue[1];
                            } else if(parseInt(defaultValue, 10) === 2){//护照
                                defaultValue = idTypeValue[2];
                            } else if(parseInt(defaultValue, 10) === 5){//外国人永久居留身份证
                                defaultValue = idTypeValue[3];
                            } else if(parseInt(defaultValue, 10) === 6){//港澳台居民居住证
                                defaultValue = idTypeValue[4];
                            } else if(parseInt(defaultValue, 10) === 7){//台湾居民来往大陆通行证
                                defaultValue = idTypeValue[6];
                            }
                            else{
                                defaultValue = idTypeValue[5];//Others
                            } 
                        }
                        if (item === 'registerCountry') {
                            defaultValue = staticData && staticData.map(options => {
                                if ( content[item] === options.indicator) {
                                    return getContentByLocal(options.leveLocales, selectedLanguage)
                                }
                            })
                        }
                        if (item === 'comDocType') {
                            defaultValue = comDocType[defaultValue] || '';
                        }
                        return itemValue[item] && content[item] ? (
                            <div className='preview-list-ul' key={index}>
                                <p className="preview-l" data-key={`questionTitle-${item}`}>{itemValue[item]}</p>
                                <p className="preview-r" data-key={`Answer-${item}`}>{defaultValue}</p>
                            </div>
                        ) : null
                    })
                }
            </div>
        </div>
    );
};

ApplicationAndCompany.propType = {
    dataId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tip: PropTypes.string.isRequired,
    staticData: PropTypes.array
};
ApplicationAndCompany.defaultProps = {
    staticData: []
};
export default ApplicationAndCompany;


// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/components/ApplicationAndCompany.js